import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import {
  LOCAL_STORAGE_KEY_ACCESS_TOKEN,
  removeLocalStorage,
} from '../../../core/commom/localStorage';
import BrainLoadingWrapper from '../../../core/components/molecules/BrainLoading';
import env from '../../../core/env';
import { resetAll } from '../../../core/hooks/useResetStore';
import { useAccessControlStore } from '../../../core/stores/accessControlStore';
import { useFreeHistoryStore } from '../../../core/stores/freeHistoryStore';
import { useUserStore } from '../stores/authStore';

const Logout = () => {
  const navigate = useNavigate();
  const [loggedOut, setLoggedOut] = useState(false);
  const redirectTo = useRef('');

  useEffect(() => {
    onLogout();
  }, []);

  const onLogout = async () => {
    const response = await logout();

    if (response) {
      setLoggedOut(true);
    }
  };

  useEffect(() => {
    if (loggedOut) {
      if (redirectTo.current) {
        navigate(redirectTo.current);
        return;
      }
      navigate('/login');
    }
  }, [loggedOut]);

  const logout = async () => {
    try {
      removeLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN);

      const token_key = env.REACT_APP_COOKIE_NAME;

      const cookies = new Cookies(null, {
        path: '/',
        domain: env.REACT_APP_COOKIE_DOMAIN,
      });
      cookies.remove(token_key);

      const currentUser = useUserStore.getState().user;
      if (currentUser && currentUser.isB2B && currentUser.B2BCompany) {
        redirectTo.current = `/login/${currentUser.B2BCompany}`;
      }

      const setUser = useUserStore.getState().setUser;
      const setPermissions = useAccessControlStore.getState().setPermissions;
      const setIsFreeUser = useAccessControlStore.getState().setIsFreeUser;
      const setViewedContent = useFreeHistoryStore.getState().setViewedContent;

      resetAll();
      setPermissions([]);
      setIsFreeUser(false);
      setViewedContent([]);
      setUser(null, false, false);
      setViewedContent([])

      return true;
    } catch (error) {
      return false;
    }
  };

  return <BrainLoadingWrapper />;
};

export default Logout;
